module.exports = __webpack_public_path__ + "img/35-mob.19267074.svg";